import gql from "graphql-tag";

export const GET_SPECIES = gql`
  query {
    getSpecies {
      speciesList {
        id
        name
      }
    }
  }
`;

export const GET_SPECIES_LIST1 = gql`
  query GETSPECIESLIST(
    $search: String
    $page: Int
    $per_page: Int
    $order_by: OrderByInput
  ) {
    getSpeciesList(
      search: $search
      page: $page
      per_page: $per_page
      order_by: $order_by
    ) {
      total
      speciesList {
        id
        name
        created_at
      }
    }
  }
`;

export const GET_EXPERIMENTS = gql`
  query GETEXPERIMENTS($species_id: ID!) {
    getExperiments(id: $species_id) {
      experimentList {
        id
        name
      }
    }
  }
`;

export const GET_EXPERIMENTS_LIST = gql`
  query GETEXPERIMENTLIST(
    $search: String
    $page: Int
    $per_page: Int
    $order_by: OrderByInputExperiment
  ) {
    getExperimentList(
      search: $search
      page: $page
      per_page: $per_page
      order_by: $order_by
    ) {
      total
      experimentList {
        id
        name
        species_id
        species
        created_at
      }
    }
  }
`;

export const GET_SYMBOLS = gql`
  query GETSYMBOLS($symbol_id: ID!) {
    getSymbols(id: $symbol_id) {
      symbolList {
        symbol
      }
    }
  }
`;

export const GET_EXPERIMENTS_LEGEND = gql`
  query GETEXPERIMENTSLEGEND($experiment_id: ID!) {
    expLegend(experiment_id: $experiment_id) {
      data {
        cluster_name
        cluster
        n_cells
      }
    }
  }
`;

export const GET_ALL_CELL_EXPERIMENTS = gql`
  query GETALLCELLEXPERIMENTS($experiment_id: ID!, $stage: String!) {
    allCellExp(experiment_id: $experiment_id, stage: $stage) {
      data {
        cluster_name
        cluster
        cell
        cell_type
        n_umi
        tissue
        tsne
        tsne_1
        tsne_2
      }
    }
  }
`;

export const CELL_EXPERIMENT = gql`
  query CELLEXPERIMENT($id: ID!, $experiment_id: ID!) {
    cellExp(id: $id, experiment_id: $experiment_id) {
      data {
        cluster_name
        cluster
        cell
        cell_type
        count
        tissue
        tsne
        tsne_1
        tsne_2
      }
    }
  }
`;

export const CSVUPLOAD_MUTATION = gql`
  mutation CSVUPLOAD(
    $fileName: String!
    $experiment_id: String!
    $key: String!
    $location: String!
    $type: String!
  ) {
    csvUpload(
      fileInput: {
        filename: $fileName
        experiment_id: $experiment_id
        key: $key
        location: $location
        type: $type
      }
    ) {
      location
      addedRowsCount
    }
  }
`;

export const CSVUPLOAD_LOGS_QUERY = gql`
  query {
    userUploads {
      data {
        id
        file_name
        file_url
        total_added_rows
        invalid_file_url
        total_invalid_rows
        created_at
      }
    }
  }
`;
export const CELL_EXPERIMENT_INTERSECTION = gql`
  query CELLEXPERIMENTINTERSECTION($ids: [ID!]!, $experiment_id: ID!) {
    intersectionExp(ids: $ids, experiment_id: $experiment_id) {
      data {
        cluster_name
        cluster
        cell
        cell_type
        count
        tissue
        tsne
        tsne_1
        tsne_2
      }
    }
  }
`;

export const ADD_EXPERIMENT = gql`
  mutation ADD_EXPERIMENT($name: String!, $species_id: String!) {
    addExperiments(name: $name, species_id: $species_id) {
      id
      name
    }
  }
`;

export const UPDATE_EXPERIMENT = gql`
  mutation UPDATE_EXPERIMENT(
    $id: String!
    $name: String!
    $species_id: String!
    $is_deleted: Boolean!
  ) {
    updateExperiments(
      id: $id
      name: $name
      species_id: $species_id
      is_deleted: $is_deleted
    ) {
      id
      name
    }
  }
`;

export const ADD_SPECIES = gql`
  mutation ADD_SPECIES($name: String!) {
    addSpecies(name: $name) {
      id
      name
    }
  }
`;

export const UPDATE_SPECIES = gql`
  mutation UPDATE_SPECIES($id: String!, $name: String!, $is_deleted: Boolean!) {
    updateSpecies(id: $id, name: $name, is_deleted: $is_deleted) {
      id
      name
    }
  }
`;
